import { createSelector } from "@reduxjs/toolkit";

export const selectUserProfileState = createSelector(
	state => state,
	state => {
		if ("userProfile" in state) return state.userProfile;
		return { username: null, email: null, avatar: null, signupSource: null };
	}
);

export const selectUserProfile = createSelector(
	selectUserProfileState,
	profile => profile
);

export const selectUsername = createSelector(
	selectUserProfileState,
	profile => profile.username
);

export const selectUserEmail = createSelector(
	selectUserProfileState,
	profile => profile.email
);

export const selectUserAvatar = createSelector(
	selectUserProfileState,
	profile => profile.avatar
);

export const selectSignupSource = createSelector(
	selectUserProfileState,
	profile => profile.signupSource
);

